module.exports = __webpack_public_path__ + "fonts/juana-regular-webfont.231e29c.woff2";